"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _signatures;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationType = void 0;
var OperationType;
(function (OperationType) {
    OperationType[OperationType["Call"] = 0] = "Call";
    OperationType[OperationType["DelegateCall"] = 1] = "DelegateCall"; // 1
})(OperationType = exports.OperationType || (exports.OperationType = {}));
class SafeTransaction {
    constructor(data) {
        _signatures.set(this, new Map());
        this.data = data;
    }
    get signatures() {
        return new Map(__classPrivateFieldGet(this, _signatures));
    }
    addSignature(signature) {
        __classPrivateFieldGet(this, _signatures).set(signature.signer.toLowerCase(), signature);
    }
    encodedSignatures() {
        const signers = Array.from(__classPrivateFieldGet(this, _signatures).keys()).sort();
        const baseOffset = signers.length * 65;
        let staticParts = '';
        let dynamicParts = '';
        signers.forEach((signerAddress) => {
            const signature = __classPrivateFieldGet(this, _signatures).get(signerAddress);
            staticParts += signature === null || signature === void 0 ? void 0 : signature.staticPart( /*baseOffset + dynamicParts.length / 2*/).slice(2);
            dynamicParts += signature === null || signature === void 0 ? void 0 : signature.dynamicPart();
        });
        return '0x' + staticParts + dynamicParts;
    }
}
_signatures = new WeakMap();
exports.default = SafeTransaction;
//# sourceMappingURL=SafeTransaction.js.map